<template>
  <li
    :class="{ 'boss-period-end': !isPublished }"
    class="boss-scoutandlike-item"
  >
    <div class="boss-main-content-wrap">
      <h2
        :class="{ 'boss-contract': isPublished }"
        class="boss-joboffer-title"
      >
        求人ID:{{ job.id }} {{ job.managementName }}
      </h2>
      <div class="boss-scoutandlike-item-list">
        <scout-topic-recommendation
          :job-id="job.id"
          :contract-id="contractId"
        />
        <scout-topic-search-condition
          :job-id="job.id"
          :search-condition-id="searchConditionId"
          :contract-id="contractId"
        />
        <scout-topic-under-review
          :job-id="job.id"
          :contract-id="contractId"
          :count="candidatesCount"
        />
        <scout-topic-liked
          :job-id="job.id"
          :contract-id="contractId"
          :count="likedCount"
          :is-auto-liked-enabled="isAutoLikedEnabled"
          :can-send-liked="canSendLiked"
        />
        <scout-topic-scouted
          :job-id="job.id"
          :contract-id="contractId"
          :scout-end-date="job.scoutEndDate"
          :count="scoutedCount"
        />
        <scout-topic-reservation
          :job-id="job.id"
          :contract-id="contractId"
          :reservation-count="reservationCount"
          :reservation-user-count="reservationUserCount"
        />
      </div>
    </div>
  </li>
</template>

<script>
import ScoutTopicSearchCondition from '@/components/molecules/ScoutTopicSearchCondition'
import ScoutTopicUnderReview from '@/components/molecules/ScoutTopicUnderReview'
import ScoutTopicRecommendation from '@/components/molecules/ScoutTopicRecommendation'
import ScoutTopicLiked from '@/components/molecules/ScoutTopicLiked'
import ScoutTopicScouted from '@/components/molecules/ScoutTopicScouted'
import ScoutTopicReservation from '@/components/molecules/ScoutTopicReservation'

export default {
  components: {
    ScoutTopicSearchCondition,
    ScoutTopicUnderReview,
    ScoutTopicRecommendation,
    ScoutTopicLiked,
    ScoutTopicScouted,
    ScoutTopicReservation
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    associatedUserCountWithJob: {
      type: Object,
      required: true
    },
    isRemainingLikeAmount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    canSendLiked () {
      return this.job.isPublished && this.isRemainingLikeAmount
    },
    isPublished () {
      return this.job.isPublished
    },
    searchConditionId () {
      return this.associatedUserCountWithJob.latestSearchConditionId
    },
    candidatesCount () {
      return this.associatedUserCountWithJob.candidatesCount
    },
    likedCount () {
      return this.associatedUserCountWithJob.likedCount
    },
    isAutoLikedEnabled () {
      return this.associatedUserCountWithJob.isAutoLikedEnabled
    },
    scoutedCount () {
      return this.associatedUserCountWithJob.scoutedCount
    },
    reservationCount () {
      return this.associatedUserCountWithJob.reservationCount
    },
    reservationUserCount () {
      return this.associatedUserCountWithJob.reservationUserCount
    }
  }
}
</script>
